import * as React from "react";

import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import PageLoadingSkeleton from "components/PageLoadingSkeleton";

const RemoteSummary = React.lazy(() => import("codat-data-ui/Summary"));

interface SummaryProps {
  companyId: string;
}
const Summary = ({ companyId }: SummaryProps) => (
  <React.Suspense fallback={<PageLoadingSkeleton />}>
    <ErrorBoundary>
      <RemoteSummary companyId={companyId} />
    </ErrorBoundary>
  </React.Suspense>
);

export default Summary;
